import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaDetalhamentoDespesas: [],
    removeAdministracaoConsultaDetalhamentoDespesas: [],
    removeOrgaoConsultaDetalhamentoDespesas: [],
    removeRecursoConsultaDetalhamentoDespesas: [],
    removeDestinacaoConsultaDetalhamentoDespesas: [],
    setMostraAplicarFiltroConsultaDetalhamentoDespesas: [],
    limpaFiltroConsultaDetalhamentoDespesas: [],
    aplicarFiltroConsultaDetalhamentoDespesas: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    orgaos: [],
    recurso: [],
    destinacao: [],
    mostraAplicarFiltro: false,
    status: '',
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeOrgao = (state = INITIAL_STATE, action) => {
    state.orgaos.splice(state.orgaos.indexOf(action.orgao))
    state.orgaos = Array.from(state.orgaos)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_DETALHAMENTO_DESPESAS]: removeExercicio,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_DETALHAMENTO_DESPESAS]: removeAdministracao,
    [Types.REMOVE_ORGAO_CONSULTA_DETALHAMENTO_DESPESAS]: removeOrgao,
    [Types.REMOVE_RECURSO_CONSULTA_DETALHAMENTO_DESPESAS]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_DETALHAMENTO_DESPESAS]: removeDestinacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_DETALHAMENTO_DESPESAS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_DETALHAMENTO_DESPESAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_DETALHAMENTO_DESPESAS]: aplicarFiltro,
})
